<template>
    <div class="copy_area">
        <div class="copy_item" v-for="(item,i) in cdkInfo.cdk" :key="i">
            <span class="copy_text">{{ item }}</span>
            <span class="copy_btn" @click="copy(item)">复制</span>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cdkInfo: this.selection.cdk
            }
        },
        methods: {
            copy(k) {
                var that = this;
                this.$copyText(k).then(() => {
                    that.$Message.success("复制成功");
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    .copy_area {
        .copy_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: .6rem;
            margin-bottom: .8rem;

            .copy_text {
                color: #9e9e9e;
            }

            .copy_btn {
                color: #670000;
                cursor: pointer;

                &:active {
                    opacity: 0.8;
                }
            }
        }
    }
</style>